/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Bridge_Default_Invoke_OnlyInputs */



/**
* | output |
* | --- |
* | "On by default — this connector has no native tool surface, so the assistant reaches it through its API." |
*
* @param {Api_Bridge_Default_Invoke_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_bridge_default_invoke_only = /** @type {((inputs?: Api_Bridge_Default_Invoke_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Bridge_Default_Invoke_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Standardmäßig an — dieser Connector hat keine native Tool-Oberfläche, daher erreicht der Assistent ihn über seine API.")
	return /** @type {LocalizedString} */ ("On by default — this connector has no native tool surface, so the assistant reaches it through its API.")
});